import { getGlobalHeadersAsObject } from "../global-headers";

export interface GetProfilesQueueItem {
	id: number;
	created: string;
	type: string;
	priority: number;
	profile_type: number;
	bot_id: number | null;
}

export interface GetProfilesQueueResponse {
	results: GetProfilesQueueItem[];
}

export async function getPersonGetProfilesQueue(
	personId: number
): Promise<GetProfilesQueueResponse> {
	const response = await fetch(`/api/v2/persons/${personId}/get_profiles_queue/`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			...getGlobalHeadersAsObject(),
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch GetProfilesQueue: ${response.status}`);
	}

	return response.json();
}
